module.exports = __webpack_public_path__ + "img/armaBoca3.09579670.jpg";